import {FC, cloneElement} from 'react';
import {FormattedMessage} from 'react-intl';
import * as Types from 'graphql-let/__generated__/__types__';
import {translations} from '@constants/Disposition';
import {Disposition} from '.cache/__types__';

export type AdvertTitleProps = {
    offerType: Types.OfferType;
    estateType: Types.EstateType;
    disposition: Types.Disposition | null | undefined;
    surface: number;
    isRk?: boolean;
};

export const AdvertTitle: FC<AdvertTitleProps> = ({offerType, estateType, surface, disposition, isRk = false}) => {
    if (!disposition || disposition === Disposition.Undefined) {
        return (
            <FormattedMessage
                defaultMessage={
                    '{offerType, select, PRODEJ {Prodej} PRONAJEM {Pronájem} SPOLUBYDLENI {Nabídka spolubydlení v rámci} other {}} {estateType, select, BYT {bytu} DUM {domu} KANCELAR {kanceláře} POZEMEK {pozemku} GARAZ {garáže} NEBYTOVY_PROSTOR {nebytového prostoru} REKREACNI_OBJEKT {rekreačního objektu} other {}} • {surface}\u00a0m²{rk, select, no { bez\u00a0realitky} other {}}'
                }
                values={{
                    offerType: offerType,
                    estateType: estateType,
                    surface: surface,
                    rk: isRk ? 'yes' : 'no',
                }}
            />
        );
    }

    const dispositionTranslation = translations[disposition];
    const children = (message: string) => (
        <FormattedMessage
            defaultMessage={
                '{offerType, select, PRODEJ {Prodej} PRONAJEM {Pronájem} SPOLUBYDLENI {Nabídka spolubydlení v rámci} other {}} {estateType, select, BYT {bytu} DUM {domu} KANCELAR {kanceláře} POZEMEK {pozemku} GARAZ {garáže} NEBYTOVY_PROSTOR {nebytového prostoru} REKREACNI_OBJEKT {rekreačního objektu} other {}} {disposition} • {surface}\u00a0m²{rk, select, no { bez\u00a0realitky} other {}}'
            }
            values={{
                offerType: offerType,
                estateType: estateType,
                disposition: message,
                surface: surface,
                rk: isRk ? 'yes' : 'no',
            }}
        />
    );

    return cloneElement(dispositionTranslation, dispositionTranslation.props, children);
};
